var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}}),_c('mam-subscrpit-dialog'),_c('mam-master-and-social-sub-account-edit-subscrpit-dialog'),_c('mam-sub-account-edit-subscrpit-dialog'),_c('open-mt4-account-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }